import styled from "styled-components";
import {FaqItem} from "../../atom/Faq";
import SectionTitle from "./sectionTitle";
import Breakpoints from "../../config/Breakpoints";

export const FaqSectionStyles = `
    
`;

const FaqSection = ({sectionData, promoData}) => {
    const FaqSectionContainer = styled.section`
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;
        width: 50rem;

        ul {
            padding: 0;
            margin: 0;
        }

        @media ${Breakpoints.max.xs} {
            margin-top: 0;
            margin-left: 0;
            margin-right: 0;
            width: 100%;
        }

        @media ${Breakpoints.max.sm} {
            width: 100%;
        }
    `;
    return (
        <>
            <SectionTitle>{sectionData.title}</SectionTitle>
            <FaqSectionContainer>
                <ul>
                    {sectionData.faqs.map(item => (
                        <FaqItem key={item.Id} question={item.V_Question__c} answer={item.V_Answer__c} />
                    ))}
                </ul>
            </FaqSectionContainer>
        </>
    );
};

export default FaqSection;
